module.exports = __webpack_public_path__ + "img/appAsset-brand--webpayLogo.411f5df7.svg";